import {
  Box,
  Container,
  Grid,
  Typography,
  makeStyles,
} from "@material-ui/core";
import React from "react";
import "./ShipWith.css";
import CheckIcon from "../../../Image/check-mark 1.png";
import WithUsImage from "../../../Image/withUsImage.png";

const useStyles = makeStyles({
  withUsMainLeft: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
});

const ShipWith = () => {
  const classes = useStyles();
  return (
    <div>
      <Container>
        <div className="withUsMain">
          <Grid container spacing={0}>
            <Grid item xs={12} lg={8} md={8}>
              <Box className="side_title">
                <Typography variant="h2">Ship with us</Typography>
              </Box>
              <Box className={classes.withUsMainLeft}>
                <Box className="icon_box">
                  <img src={CheckIcon} alt="CheckIcon" />
                </Box>
                <Box className="withUsMain_text">
                  <Typography variant="h6">GPS Enabled Tracking</Typography>
                </Box>
              </Box>
              <Box className={classes.withUsMainLeft}>
                <Box className="icon_box">
                  <img src={CheckIcon} alt="CheckIcon" />
                </Box>
                <Box className="withUsMain_text">
                  <Typography variant="h6">Ontime Delivery</Typography>
                </Box>
              </Box>
              <Box className={classes.withUsMainLeft}>
                <Box className="icon_box">
                  <img src={CheckIcon} alt="CheckIcon" />
                </Box>
                <Box className="withUsMain_text">
                  <Typography variant="h6">Zero percent Damage Risk</Typography>
                </Box>
              </Box>
              <Box className={classes.withUsMainLeft}>
                <Box className="icon_box">
                  <img src={CheckIcon} alt="CheckIcon" />
                </Box>
                <Box className="withUsMain_text">
                  <Typography variant="h6">
                    Both LTL/FTL options available
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} lg={4} md={4}>
              <Box className="withUsMainRight">
                <img src={WithUsImage} alt="WithUsImage" />
              </Box>
            </Grid>
          </Grid>
        </div>
      </Container>
    </div>
  );
};

export default ShipWith;
